// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2v28F","footer":"ChangeClinic_footer__vHOb2"};